<template>
  <div :class="['report-pagination-list', referenceObjParam && referenceObjParam.type === 'rc-report' && 'rc-report-width']" ref="reportList" :style="{height: contentHeight}">
     <!-- 批量处理部分 -->
    <transition name="el-fade-in-linear">
      <div v-if="batchData.isBatch&&!this.report.handleHidden" class="batch-handle" :style="{'left':this.leftMenu.width+'px'}">
        <p class="number">已选择{{batchData.handleType===1?'本页':'全部'}}{{batchData.count}}条数据</p>
        <div class="batch-edit" @click="editBatch">编辑</div>
        <div class="batch-del"  @click="delBatch">删除</div>
      </div>
    </transition>
    <el-table
      :height="tableHeight"
      ref="table"
      border
      highlight-current-row
      :data="data"
      :class="['table-list', data && data.length === 0 && 'table-none-data', referenceObjParam && referenceObjParam.type === 'rc-report' && 'rc-report-width']"
      v-loading="loading"
      @sort-change="sort"
      @row-dblclick="rowDbClick"
      @row-click="rowClick"
      @current-change='changeCurrentRow'
      :cell-style='cellStyle'
      @cell-click="cellClick"
      cell-class-name="cell-padding"
      :header-cell-class-name="sortVisibility"
      :row-style="rowStyle"
      :show-summary='hasSummary'
      :summary-method="getSummaries"
      :row-class-name="getRowClassName"
      :span-method="objectSpanMethod"
      @header-dragend="headerDragend"
      :empty-text='" "'
      @cell-mouse-leave="mouseLeave"
      :expand-row-keys="expands"
      row-key="_uuid"
      @expand-change="expandChange">
      <!-- 风琴列 -->
      <el-table-column type="expand" fixed v-if="getExpandChildren && getExpandChildren.length && !hasChildren" width="20">
        <template slot-scope="props">
          <children-expand ref="childrenExpand" v-if="expands.includes(props.row._uuid)" :children='getExpandChildren' :current-row='currentRow' :formRuntimeDialog="formRuntimeDialog" :height="tablePageHeight" :expandParams="expandParams"/>
        </template>
      </el-table-column>
      <!-- 索引列 -->
      <el-table-column
      v-if="!report.batchHandle"
      label="序号"
      fixed
      type="index"
      align="center"
      :index="indexMethod"
      class-name="numerical serial-number">
      </el-table-column>
      <!-- 编辑模式列 -->
      <el-table-column
        v-if="report.batchHandle"
        width="85"
        fixed
        align="center"
        class-name="numerical numerical-batchHandle">
        <template slot="header" slot-scope="scope">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
          <el-dropdown trigger="click" placement="bottom-start">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
           <el-dropdown-menu slot="dropdown" class="dropdown-batch">
            <el-dropdown-item><div @click="handleCheckCurrentPage">选择本页记录</div></el-dropdown-item>
            <el-dropdown-item> <div @click="handleCheckAllPage">选择所有记录</div></el-dropdown-item>
           </el-dropdown-menu>
         </el-dropdown>
        </template>
        <template slot-scope="scope">
          <slot :row="scope.row" :$index="scope.$index">
           <div @mouseleave="batchData.activeIndex=0">
              <el-checkbox v-if="batchData.activeIndex===indexMethod(scope.$index)||scope.row.checked" v-model="scope.row.checked" @change="checkCurrent(scope.row)"></el-checkbox>
              <div @mouseenter="batchData.activeIndex=indexMethod(scope.$index)" v-else>{{indexMethod(scope.$index)}}</div>
            </div>
          </slot>
        </template>
      </el-table-column>
      <!-- 操作列 -->
      <el-table-column
        v-if="getUpdateOrDelButtons && getUpdateOrDelButtons.length > 0&&(report.operationPosition==='left'||report.operationPosition===true)"
        :width="operationWidth"
        :fixed="report.operationPosition?'left':'right'"
        align="center"
        label="操作"
        class-name="operation-button-column">
        <template slot-scope="scope">
          <template v-for="(button,index) in getUpdateOrDelButtons">
          <el-tooltip :content="button.getName ? button.getName({row:scope.row,button}) : button.name" :key="index" :disabled="button.name.length<=5">
          <el-button
            class="button-margin"
            v-if="index<3"
            :key="button.id"
            :disabled="button.getDisabled ? button.getDisabled({row:scope.row,button}) : isDisabled(scope.row,button)"
            @click.native.prevent="doAction(button, scope.row.Id,report.mainTableId,report.name, scope.row)"
            type="text">
            {{ button.getName ? button.getName({row:scope.row,button}) : button.name | overflowWord}}
          </el-button>
          </el-tooltip>
          </template>
          <el-dropdown class="label-margin" v-if="getUpdateOrDelButtons.length>3" :hide-timeout="500" @command="handleCommand">
            <span class="dropdown-menu">
            <i class="fa fa-chevron-circle-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="index>2"
                v-for="(button,index) in getUpdateOrDelButtons"
                :key="index"
                :disabled="button.getDisabled ? button.getDisabled({row:scope.row,button}) : isDisabled(scope.row,button)"
                :command="{'button':button,'rowId': scope.row.Id,'mainTableId':report.mainTableId,'name':report.name,'row':scope.row}">
                {{ button.getName ? button.getName({row:scope.row,button}) : button.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </template>
      </el-table-column>
      <template v-for="(column, index) in report.columns">
        <!-- 文件列表列 -->
        <el-table-column
          v-if="column.columnType.toLowerCase() === 'file' && !column.hidden"
          :width="(column.format && column.format.dataFormat && column.format.dataFormat.width)"
          :min-width="(column.format && column.format.dataFormat && column.format.dataFormat.width)||120"
          :class-name="getColumnClass(column)"
          :fixed="fixedColumn(index)"
          :label="column.name"
          :key="index"
          :align="(column.format && column.format.dataFormat && column.format.dataFormat.align)||'center'"
          :formatter="formatter"
          :show-overflow-tooltip="true"
          sortable="custom">
          <template slot="header" slot-scope="{column, $index}">
            <span :title="column.label">{{column.label}}</span>
          </template>
          <template slot-scope="scope" >
            <!-- 文件列提取为了一个组件 -->
            <!-- 图片列 且 开启了图片展示-->
            <image-column v-if="showPicture(column).show" :data="scope.row[column.id]" :showPicture="showPicture(column)"></image-column>
            <file-column v-else :data="scope.row[column.id]" :column="column"></file-column>
          </template>
        </el-table-column>
        <!-- 非文件列表列 -->
        <el-table-column
          v-if="column.columnType.toLowerCase() !== 'file'&&!column.hidden"
          :width="getWidth(column)"
          :class="[notSafari&&'notSafari']"
          min-width="120"
          :class-name="getColumnClass(column)"
          :fixed="fixedColumn(index)"
          :prop="column.id"
          :label="column.name"
          :key="index"
          :align="(column.format && column.format.dataFormat && column.format.dataFormat.align)||'center'"
          :formatter="formatter"
          :show-overflow-tooltip="!judgeColumn(column)"
          sortable="custom">
          <template slot="header" slot-scope="{row, column, $index}">
            <span :title="column.label">{{column.label}}</span>
          </template>
          <template v-if="column.basis">
            <el-table-column v-for="(item,index) in column.splitColumns"
                :render-header="renderHeader"
                :width="(column.format && column.format.dataFormat && column.format.dataFormat.width/column.splitColumns.length)"
                :min-width="(column.format && column.format.dataFormat && column.format.dataFormat.width/column.splitColumns.length)||(120/column.splitColumns.length)"
                :prop="item.id"
                :label="item.name"
                :key="index"
                 label-class-name="label-cell"
                :show-overflow-tooltip="true"
                :class-name="getColumnClass(column)">
            </el-table-column>
          </template>
          <template slot-scope="scope">
            <!-- 开启了列编辑 -->
            <!--<template v-if="report.columnEdit">-->
              <!--&lt;!&ndash; 开启了列编辑的列 &ndash;&gt;-->
              <!--<template v-if="judgeColumn(column)">-->
                <!--<component v-if="allComponent.length && Object.keys(getComponentType(column)).length" ref="editColmun" :is="getComponentType(column)" :data="scope.row" :column="column" :component="getComponent(column)" :width="width" :form="formDefinition" :report="report" :comboboxDataSource="comboboxDataSource" @setDataSource="setDataSource" @updateColumn="updateColumn" :allComponent="allComponent"></component>-->
              <!--</template>-->
              <!--&lt;!&ndash; 未开启列编辑的列 &ndash;&gt;-->
              <!--<template v-else-if="isFileData(column.columnType, scope.row[column.id])">-->
                <!--&lt;!&ndash;文件列&ndash;&gt;-->
                <!--<file-column :data="scope.row[column.id]" :column="column"></file-column>-->
              <!--</template>-->
              <!--<template v-else>{{ formatter(scope.row, {property: column.id}) }}</template>-->
            <!--</template>-->
            <!--todo :开启了 进度条展示 就无法列编辑, 如果后续变更可能需要改变这里的判断-->
            <!-- 开启了进度条展示的列 -->
            <template v-if="column.progressDisplay">
              <progress-column :data="scope.row[column.id]">
                <span slot="isNaNData" v-html="formatter(scope.row, {property: column.id})"></span>
              </progress-column>
            </template>
            <!-- 开启了列编辑的列 -->
             <template v-else-if="report.columnEdit && judgeColumn(column)">
              <component v-if="allComponent.length && Object.keys(getComponentType(column)).length" ref="editColmun"
              :is="getComponentType(column)"
              :data="scope.row"
              :column="column"
              :component="getComponent(column)"
              :width="width" :form="formDefinition"
              :report="report"
              :comboboxDataSource="comboboxDataSource"
              @setDataSource="setDataSource"
              @updateColumn="updateColumn"
              @doColumnAction="doColumnAction(scope.row.Id,scope.row)"
              :allComponent="allComponent"></component>
            </template>
            <!-- 数据源控件和下拉框选择了文件的情况(fixme: 根据值包含$.$来判断是否选择了文件, 不严谨)-->
            <template v-else-if="isFileData(column.columnType, scope.row[column.id])">
              <!-- 文件列提取为了一个组件 -->
              <file-column :data="scope.row[column.id]" :column="column"></file-column>
            </template>
            <!-- 未开启列编辑 -->
            <template v-else>
               <a v-if="report.clickColumn.appointColumn===column.id" class="appoint-column-name" v-html="formatter(scope.row, {property: column.id})" @click="doColumnAction(scope.row.Id,scope.row)"></a>
              <span v-else v-html="formatter(scope.row, {property: column.id})"></span>
              <!--{{ formatter(scope.row, {property: column.id}) }}-->
            </template>
          </template>
        </el-table-column>
      </template>
      <!-- 不知道啥玩意的操作列 -->
      <el-table-column
        v-if="getUpdateOrDelButtons && getUpdateOrDelButtons.length > 0&&(report.operationPosition!=='left'&&report.operationPosition!==true)"
        :width="operationWidth"
        :fixed="report.operationPosition?'left':'right'"
        align="center"
        label="操作"
        class-name="operation-button-column">
        <template slot-scope="scope">
          <template v-for="(button,index) in getUpdateOrDelButtons">
          <el-tooltip :content="button.getName ? button.getName({row:scope.row,button}) : button.name" :key="index" :disabled="button.name.length<=5">
          <el-button
            class="button-margin"
            v-if="index<3"
            :key="button.id"
            :disabled="button.getDisabled ? button.getDisabled({row:scope.row,button}) : isDisabled(scope.row,button)"
            @click.native.prevent="doAction(button, scope.row.Id,report.mainTableId,report.name, scope.row)"
            type="text">
            {{ button.getName ? button.getName({row:scope.row,button}) : button.name | overflowWord}}
          </el-button>
          </el-tooltip>
          </template>
          <el-dropdown class="label-margin" v-if="getUpdateOrDelButtons.length>3" :hide-timeout="500" @command="handleCommand">
            <span class="dropdown-menu">
            <i class="fa fa-chevron-circle-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="index>2"
                v-for="(button,index) in getUpdateOrDelButtons"
                :key="index"
                :disabled="button.getDisabled ? button.getDisabled({row:scope.row,button}) : isDisabled(scope.row,button)"
                :command="{'button':button,'rowId': scope.row.Id,'mainTableId':report.mainTableId,'name':report.name,'row':scope.row}">
                {{ button.getName ? button.getName({row:scope.row,button}) : button.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </template>
      </el-table-column>
    </el-table>
    <el-footer v-if="!isExpand" v-show="!loading" height="32px" :class="['pagination-footer', referenceObjParam && referenceObjParam.type === 'rc-report' && 'rc-report-pagination-footer']">
      <template v-if="noPagination">
        <span class="pagination-footer__count">共{{count}}条</span>
      </template>
      <template v-else>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="pagination.pageSizes"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="count">
        </el-pagination>
      </template>
      <div class="report-footer" v-if="(report && report.footerValue) || (data[0] && data[0].footerValue)">{{data[0] ? data[0].footerValue : emptyValue}}</div>
    </el-footer>
    <el-dialog
      class="batch-dialog"
      title="批量编辑"
      :visible.sync="batchData.visible"
      width="510px"
      center
      :modal-append-to-body="false">
      <div v-if="batchData.visible">
        <p>通过批量编辑可快速统一修改相同字段的数据内容</p>
        <el-form ref="batchForm" class="batch-form" label-width="62px" label-position="left" :model="batchData">
          <el-form-item class="item-required" label="字段" prop="columnId" :rules="{required: true, message: '请选择字段', trigger: 'change'}">
            <el-select v-model="batchData.columnId" placeholder="请选择" @change=changeColumnId>
                <el-option
                    v-for="item in batchData.columns"
                    :key="item.columnId"
                    :label="item.name"
                    :value="item.columnId">
                  </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="batchData-type item-required" label="字段内容" prop="type" :rules="{required: true, message: '请选择', trigger: 'blur'}">
            <el-radio-group v-model="batchData.type">
              <el-radio :label="1">清空内容</el-radio>
              <el-radio :label="2">修改为新值</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="batchData.type===2">
            <el-form-item class="item-required" v-if="getType(batchData.columnId)==='enum'" prop="replaceValue" :rules="{required: true, message: '请选择', trigger: 'change'}">
              <el-select v-model="batchData.replaceValue" placeholder="请选择">
                <el-option
                  v-for="item in batchData.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="item-required" v-else-if="getType(batchData.columnId)==='date'" prop="replaceValue" :rules="{required: true, message: '请选择', trigger: 'blur'}">
                <el-date-picker v-model="batchData.replaceValue" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item class="item-required" v-else-if="getType(batchData.columnId)==='time'" prop="replaceValue" :rules="{required: true, message: '请选择', trigger: 'blur'}">
              <el-time-picker v-model="batchData.replaceValue" value-format="HH:mm:ss" placeholder="请选择时间"></el-time-picker>
            </el-form-item>
            <el-form-item class="item-required" v-else-if="getType(batchData.columnId)==='datetime'" prop="replaceValue" :rules="{required: true, message: '请选择', trigger: 'blur'}">
              <el-date-picker v-model="batchData.replaceValue" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期时间"></el-date-picker>
            </el-form-item>
            <el-form-item class="item-required" v-else prop="replaceValue" :rules="{required: true, message: '请选择', trigger: 'blur'}">
              <el-input v-model="batchData.replaceValue" placeholder="请输入文本内容"></el-input>
            </el-form-item>
        </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBatchData">确 定</el-button>
        <el-button @click="cancelBatchData">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'
import ReportButton from './report-button'
import { buttonMixin } from './button.js'
import {simpleCalculation} from './simpleCalculation'
import reportRcInput from './reportColumnEdit/rc-input'
import reportRcCombobox from './reportColumnEdit/rc-combobox'
import reportRcDate from './reportColumnEdit/rc-date'
import reportRcNumeric from './reportColumnEdit/rc-numeric'
import reportRcTextarea from './reportColumnEdit/rc-textarea'
import reportRcRichBox from './reportColumnEdit/rc-rich-box'
import ChildrenExpand from './children-expand.vue'
import FileColumn from './tableComponents/file-column.vue'
import ProgressColumn from './tableComponents/progress-column'
import ImageColumn from './tableComponents/image-column'
import PicturePreview from '@/components/form/runtime/components/picture-preview-swiper.vue'
export default {
  name: 'table-pagination',
  props: ['report', 'data', 'count', 'loading', 'summaryData', 'hasSummary', 'formRuntimeDialog', 'hasChildren', 'formDefinition', 'isExpand', 'renderReportFilter', 'referenceObjParam', 'filtersData', 'noPagination'],
  inject: {
    eventBus: {},
    leftMenu: {},
    childrenExpandEvent: {default: ''},
    redcatApp: {}
  },
  mixins: [buttonMixin],
  components: {
    ReportButton,
    reportRcInput,
    reportRcCombobox,
    reportRcDate,
    reportRcNumeric,
    reportRcTextarea,
    ChildrenExpand,
    FileColumn,
    reportRcRichBox,
    ProgressColumn,
    ImageColumn,
    PicturePreview
  },
  data () {
    let pageSize
    let pageSizes
    if (this.referenceObjParam) {
      // 报表控件分页
      pageSize = this.referenceObjParam.params.size
      pageSizes = [10, 15, 20, 30, 50, 100]
      if (!pageSizes.includes(pageSize)) {
        pageSizes.unshift(pageSize)
      }
    } else {
      // 主表分页
      pageSize = Number(this.report.pageNumber) === -999 ? 20 : Number(this.report.pageNumber)
      pageSizes = [10, 15, 20, 30, 50, 100]
    }
    if (this.report.children && this.hasChildren) {
      // 子表分页
      pageSizes = [10, 15, 20, 30, 50, 100]
      pageSize = 100
    }
    return {
      url: '',
      pagination: { currentPage: 1, pageSize: pageSize, pageSizes: pageSizes, sort: '' },
      myColumn: {},
      myIndex: '',
      rowStyle: {
        height: `36px`
      },
      arrayCol: {},
      // p批量处理的数据
      batchData: {
        reportId: '',
        filters: {}, // 筛选项
        isBatch: false,
        visible: false,
        columns: [],
        columnId: '',
        type: '',
        replaceValue: '',
        options: [{label: '选项1', value: '选项1'}],
        columnIds: [],
        // 编辑还是删除
        batchType: '',
        activeIndex: 0,
        handleType: 1,
        count: 0,
        removeIds: []
      },
      filterWidth: 0,
      allCount: 0,
      checkAll: false,
      isIndeterminate: false,
      allComponent: [],
      width: 0,
      comboboxDataSource: [],
      contentHeight: '100%',
      // 这个值默认值必须为null，否则你会发现新世界。
      tableHeight: null,
      expands: [],
      currentRow: '',
      tablePageHeight: 0,
      expandParams: {
        // TODO 因为elementUI的表格如果使用了fixed属性会新增表格去拼接，导致展开行内的数据会渲染fixed属性列数+1
        // TODO 目前只有索引列，展开列，操作列
        count: 1,
        // TODO 设置了fixed属性的列默认是两条，如果有新增列增加fixed属性，需要修改赋值逻辑
        fixedColumns: 2
      },
      notSafari: true,
      selectRowData: '', // 当前选中行
      selectRowPage: 1, // 当前选中行所在页码
      emptyValue: ''
    }
  },
  filters: {
    overflowWord (oldVal) {
      let newVal = ''
      if (oldVal.length > 5) {
        newVal = oldVal.slice(0, 4) + '...'
        return newVal
      } else {
        return oldVal
      }
    }
  },
  watch: {
    'pagination.currentPage' (val) {
      this.searchPage()
    },
    'pagination.pageSize' (val) {
      this.searchPage()
    },
    'data' (val) {
      if (val && val.length > 0) {
        // 默认选中第一条数据
        if (this.selectRowData) {
          // 如果编辑之前有选中数据，并且该数据还在之前选中的页码，则使用选中数据，如果没有，则不选中任何行
          if (this.selectRowPage === this.pagination.currentPage) {
            let selectRowData = ''
            selectRowData = this.data.find(c => c.Id === this.selectRowData.Id)
            if (selectRowData) {
              this.changeCurrentRow(selectRowData)
            } else {
              this.changeCurrentRow({})
            }
          }
        } else {
          this.changeCurrentRow(this.data[0])
        }
        this.handleSplitColumn(val)
      } else {
        let footer = this.report.footer
        if (this.report.footerValue) {
          footer.items ? this.emptyValue = footer.items[0].prefix + '0' + footer.items[0].suffix : this.emptyValue = JSON.parse(footer).items[0].prefix + '0' + JSON.parse(footer).items[0].suffix
        }
      }
      // 数据变过后，全选清空
      this.batchData.columnIds = this.data.filter(n => n.checked).map(m => m.Id)
      this.isIndeterminate = !!this.batchData.columnIds.length
      this.checkAll = this.batchData.columnIds.length === this.data.length
    },
    'batchData.columnIds' (val) {
      this.batchData.isBatch = val.length
      this.batchData.count = val.length
      this.checkAll = val.length === this.data.length
    },
    'formDefinition' (val) {
      if (val && Object.keys(val).length > 0) {
        this.allComponent = this.getAllComponent(val.form.form.children)
      }
    },
    'loading': {
      handler (val) {
        if (!val && this.hasChildren) {
          this.childrenExpandEvent && this.childrenExpandEvent.$emit('report.children.loaded')
        }
      },
      deep: true
    },
    $route (newValue, oldValue) {
      // 只有打开过的报表才会触发
      if (newValue && newValue.name.includes('ReportRuntime')) {
        let reports = localStorage.getItem('reportScrollTop')
        reports = reports ? JSON.parse(reports) : {}
        // 找到当前报表所对对应的报表高度
        if (reports[this.report.id]) {
          // 如果滚动条无法跳转，把时间调大
          setTimeout(() => {
            this.$refs.table.bodyWrapper.scrollTop = reports[this.report.id]
            this.$refs.table.doLayout()
          }, 300)
        }
      }
    }
  },
  created () {
    this.handleSplitColumn(this.data)
    this.notSafari = !(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))
  },
  mounted () {
    // 子表传递过来的 formDefinition 不会触发监听，所以直接使用即可
    if (this.hasChildren && this.formDefinition && Object.keys(this.formDefinition).length > 0) {
      this.allComponent = this.getAllComponent(this.formDefinition.form.form.children)
    }
    this.$nextTick(() => {
      if (!this.hasChildren) {
        this.contentHeight = this.renderReportFilter ? this.report.groupReportData.length > 1 ? 'calc(100% - 40px)' : 'calc(100% - 35px)' : '100%'
        if (this.getJustHaveMoreTypeFilter()) {
          this.contentHeight = 'calc(100% - 8px)'
        }
      } else {
        this.contentHeight = 'auto'
      }
      if (this.isExpand) {
        this.contentHeight = this.renderReportFilter ? '214px' : '249px'
      }
      this.tableHeight = this.getTableHeight()
      if (document.querySelector('.el-table__fixed .el-table__fixed-header-wrapper .el-table__header')) {
        this.columnFixWidth = document.querySelector('.el-table__fixed .el-table__fixed-header-wrapper .el-table__header').offsetWidth - document.querySelector('.el-table__fixed').offsetWidth
      }
      if (document.querySelector('.el-table--border .el-table__fixed-right .el-table__fixed-header-wrapper .el-table__header')) {
        this.columnFixRightWidth = document.querySelector('.el-table--border .el-table__fixed-right .el-table__fixed-header-wrapper .el-table__header').offsetWidth - document.querySelector('.el-table--border .el-table__fixed-right').offsetWidth
      }
      // 如果有操作列 则fixedColumns+1
      this.getUpdateOrDelButtons && this.getUpdateOrDelButtons.length > 0 && this.expandParams.fixedColumns++
    })
    this.report.mergeSame.forEach(m => {
      this.arrayCol[m] = []
    })
    this.$nextTick(() => {
      // 报表控件隐藏列排序
      if (this.referenceObjParam) {
        this.$refs.table.$children[4].$el.querySelectorAll('.caret-wrapper').forEach(item => {
          item.style.visibility = 'hidden'
        })
        this.$refs.table.$el.querySelector('.el-table__header-wrapper').style['pointer-events'] = 'none'
      }
    })
  },
  updated () {
    // 数据更新时对表格强制重新渲染 , 处理表格的一些布局问题
    this.$refs.table.doLayout()
  },
  methods: {
    //  设置高度
    getWidth (column) {
      let num = (column.format && column.format.dataFormat && column.format.dataFormat.width)
      if (!num && !this.notSafari) {
        return 120
      } else if (num && num < 120) {
        return 120
      } else {
        return num
      }
    },
    setHeight (val, filterRef) {
      let children = this.report.children.filter(m => m.type === 'splice')
      let contentHeight = '100%'
      // 有子表情况下
      if (children && children.length) {
        contentHeight = 'auto'
      } else {
        if (val) {
          let filter = filterRef.$el.getElementsByClassName('filterCol ')[0]
          // 需要过滤开启了更多模式的下拉选项
          let reportFilesLength = this.report.filters.filter(m => m.filterType !== 'senior' && !m.moreType).length
          if (filter && filter.offsetWidth) {
            let line = Math.ceil(reportFilesLength / parseInt(filter.offsetWidth / 224))
            let h = (line - 1) * 34
            contentHeight = `calc(100% - ${h + 45}px)`
          }
        } else {
          contentHeight = 'calc(100% - 35px)'
        }
      }
      this.contentHeight = contentHeight
    },
    headerDragend (newWidth, oldWidth, column, event) {
      let index = this.report.columns.findIndex(n => JSON.stringify(n).includes(column.property))
      if (index < this.report.freezeLeft) {
        setTimeout(() => {
          let el = document.querySelector('.el-table__fixed .el-table__fixed-header-wrapper .el-table__header')
          if (el) {
            let width = parseInt(el.style.width) - this.columnFixWidth
            document.querySelector('.el-table__fixed').style.width = width + 'px'
          }
        }, 200)
      } else if (index > this.report.columns.length - this.report.freezeRight) {
        setTimeout(() => {
          let el = document.querySelector('.el-table--border .el-table__fixed-right .el-table__fixed-header-wrapper .el-table__header')
          if (el) {
            let width = parseInt(el.style.width) - this.columnFixRightWidth
            document.querySelector('.el-table--border .el-table__fixed-right').style.width = width + 'px'
          }
        }, 200)
      }
      this.width = newWidth
    },
    renderHeader (h, {column, $index}) {
      let myColumnName = column.label
      return [
        h('el-tooltip', {attrs: {content: column.label, placement: 'top-start', effect: 'light', visibleArrow: false, popperClass: 'label-tooltip'}},
          [h('label', {}, myColumnName)])
      ]
    },
    handleSplitColumn (data) {
      // 处理表头拆分的数据
      data.forEach((m, index) => {
        for (let key in m) {
          if (Object.prototype.toString.call(m[key]) === '[object Object]') {
            let newValuesArray = Object.values(m[key])
            let newkeysArray = Object.keys(m[key])
            let column = this.report.columns.find(m => m.id === key)
            column.splitColumns = []
            newValuesArray.forEach((el, i) => {
              let newKey = key + '_' + i
              m[newKey] = el
              column.splitColumns.push({id: newKey, name: newkeysArray[i]})
            })
          }
        }
      })
    },
    getDisplayFormatConditionResult (type, data, condition) {
      let flag = false
      if (!data) {
        return flag
      }
      if (['>=', '<=', '>', '<'].some(n => type.includes(n))) {
        data = Number(data)
        condition = Number(condition)
      }
      switch (type) {
        case '==' :
          flag = data.toString() === condition.toString()
          break
        case '>=' :
          flag = data >= condition
          break
        case '<=' :
          flag = data <= condition
          break
        case '<' :
          flag = data < condition
          break
        case '>' :
          flag = data > condition
          break
        case '!=' :
          // 字符串数字与数字对比不能用全等。
          // eslint-disable-next-line
          flag = data != condition
          break
        case 'include' :
          flag = data.toString().includes(condition)
          break
        case 'exclude' :
          flag = !data.toString().includes(condition)
          break
      }
      return flag
    },
    handleDecimalDigits (roundWay, data, decimalDigits) {
      data = Number(data)
      switch (roundWay) {
        case 'rounding':
          data = _.round(data, decimalDigits)
          break
        case 'ceil':
          data = _.ceil(data, decimalDigits)
          break
        case 'floor':
          data = _.floor(data, decimalDigits)
          break
        default:
          data = data.toFixed(decimalDigits)
      }
      return data
    },
    cellClick (row, column, cell, event) {
      this.$emit('cell-click', {row, column, cell, event})
      this.expandChange(row)
    },
    cellStyle ({row, column, rowIndex, columnIndex}) {
      let color = ''
      let allhasColorFormatsColumn = this.report.columns.filter(o => !this.report.mergeSame.includes(o.id) && o.format && o.format.colorFormats && o.format.colorFormats.length !== 0)
      allhasColorFormatsColumn.forEach(m => {
        if (m.format && m.format.colorFormats) {
          m.format.colorFormats = typeof (m.format.colorFormats) === 'string' ? JSON.parse(m.format.colorFormats) : m.format.colorFormats
          m.format.colorFormats.forEach(n => {
            n.columnId = m.id
          })
        }
      })
      let allColorFormats = allhasColorFormatsColumn.map(m => m.format.colorFormats)
      allColorFormats = [].concat.apply([], allColorFormats)
      allColorFormats.forEach(n => {
        if (n.warningWaySelect === 'columns') {
          // 整列变色
          if (column.property === n.columnId) { color = `${n.color}-columns` }
        } else if (n.warningWaySelect === 'data') {
          // 数据变色
          if (column.property === n.columnId) {
            let newCondition = n.warningText ? n.condition : row[n.condition]
            let result = this.getDisplayFormatConditionResult(n.type, row[n.columnId], newCondition)
            if (result) {
              color = `${n.color}-data`
            }
          }
        } else if (n.warningWaySelect === 'rows') {
          // 整行变色
          let result = this.getDisplayFormatConditionResult(n.type, row[n.columnId], n.condition)
          if (result) {
            color = `${n.color}-rows`
          }
        }
      })
      if (color) {
        if (color.split('-')[1] === 'rows') {
          return `color:${color.split('-')[0]}`
        } else {
          return `background:${color.split('-')[0]}`
        }
      } else {
        return ''
      }
    },
    getSummaries (param) {
      const { columns } = param
      const sums = ['总计']
      const summaryData = this.summaryData
      if (Object.keys(this.summaryData).length !== 0) {
        columns.forEach((column, index) => {
          for (let key in summaryData) {
            if (column.property === key) {
              sums[index] = summaryData[key]
            }
          }
        })
      }
      return sums
    },
    // 当前行改变
    changeCurrentRow (currentRow) {
      this.currentRow = currentRow
      this.$emit('current-change', currentRow)
    },
    rowDbClick (row) {
      let btns = this.getUpdateOrDelButtons
      let btn = this.getUpdateOrDelButtons.find(e => e.type === 'update')
      // 如果有编辑按钮的权限，双击编辑
      if (btns.length > 0 && btn) {
        // 禁用的按钮不能双击打开
        let isDisable = btn.getDisabled ? btn.getDisabled({row, btn}) : !!row[btn.id]
        !isDisable && this.doActionTargetType(btn, row.Id)
      }
      this.$emit('row-dbclick')
    },
    rowClick (row) {
      this.selectRowData = row
      this.selectRowPage = this.pagination.currentPage
      this.$emit('row-click', row)
    },
    // 冻结几列
    fixedColumn (index) {
      let result = false
      if (index < this.report.freezeLeft) {
        result = 'left'
      }
      if (index > this.report.columns.length - 1 - (this.report.freezeRight - 1)) {
        result = 'right'
      }
      return result
    },
    // 数字转千分位
    comdify (n) {
      // 负数时，负号直接拼接
      let plusMinusSign = ''
      if (n.startsWith('-')) {
        plusMinusSign = '-'
        n = n.slice(1)
      }
      let re = /\d{1,3}(?=(\d{3})+$)/g
      let afterComdifyNumber = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
        return s1.replace(re, '$&,') + s2
      })
      return plusMinusSign + afterComdifyNumber
    },
    formatter (row, column) {
      let col = this.report.columns.find(m => m.id === column.property)
      let displayFormats = []
      let dataFormat = {}
      let data = row[column.property]
      if (!data) return data
      // 处理数据为boolean类型
      if (typeof data === 'boolean') {
        data = data + ''
      }
      if (data || data === 0) {
        // 判断是不是日期 并且日期的值是否存在
        if (col.columnType === 'bit') {
        // 查询的结果为布尔类型的时候, 将值转成 String 类型
          data = data + ''
        } else if (col.columnType === 'html' || col.columnType === 'HTML') {
          // 将br标签替换成空格
          data = data.replace(/<br>/, ' ')
          // 替换所有标签
          data = data.replace(/<[^>]+>/g, '')
          // 删除所有的空格标签
          data = data.replace(/&nbsp;/g, '')
        }
        if (col.useThousandth) {
          // 开启了千分位的转千分位
          data = data + ''
          data = this.comdify(data)
        }
        // 自定义显示的数据处理
        if (col.format && col.format.displayFormats) {
          displayFormats = typeof (col.format.displayFormats) === 'string' ? JSON.parse(col.format.displayFormats) : col.format.displayFormats
          displayFormats.forEach(el => {
            if (el.value && el.condition) {
              let result = this.getDisplayFormatConditionResult(el.type, data, el.condition)
              if (result) {
                data = el.value
              }
            }
          })
        }

        // 基本格式的数据处理
        if (col.format && col.format.dataFormat) {
          dataFormat = typeof (col.format.dataFormat) === 'string' ? JSON.parse(col.format.dataFormat) : col.format.dataFormat
          if (dataFormat.dataType === 'decimal') {
            data = this.handleDecimalDigits(dataFormat.roundWay, data, dataFormat.decimalDigits)
          } else if (dataFormat.dataType === 'int') {
            data = this.handleDecimalDigits('', data, 0)
          } else if (dataFormat.dataType === 'percent') {
            data = parseFloat((this.handleDecimalDigits(dataFormat.roundWay, data, dataFormat.decimalDigits) * 100).toFixed(10)) + '%'
          } else if (dataFormat.dataType === 'date') {
            if (dataFormat.dataformat === 'DA') {
              return moment(data).format('YYYY-MM-DD')
            } else if (dataFormat.dataformat === 'DB') {
              return moment(data).format('YYYY年MM月DD日')
            } else if (dataFormat.dataformat === 'DC') {
              return moment(data).format('YYYY年MM月')
            } else if (dataFormat.dataformat === 'DD') {
              return `${moment(data).year()}年第${moment(data).quarter()}季度`
            } else if (dataFormat.dataformat === 'DE') {
              let halfYear = moment(data).quarter() === 1 || moment(data).quarter() === 2 ? '上半年' : '下半年'
              return `${moment(data).year()}年${halfYear}`
            } else if (dataFormat.dataformat === 'DF') {
              return moment(data).format('MM月DD日')
            } else if (dataFormat.dataformat === 'DG') {
              return moment(data).format('MM月')
            } else if (dataFormat.dataformat === 'DH') {
              let arr = ['日', '一', '二', '三', '四', '五', '六']
              return `周${arr[moment(data).format('d')]}`
            }
          } else {
            if (col.columnType === 'datetime') {
              data = data.includes(',') ? data : moment(data).format('YYYY-MM-DD HH:mm:ss')
            } else if (col.columnType === 'date') {
              data = data.includes(',') ? data : moment(data).format('YYYY-MM-DD')
            }
          }
        }
        // 处理http文字
        data = this.findHttpText(data)
        return data
      }
    },
    // 将文本中的http开头的网址,变为可直接点击的地址
    findHttpText (data) {
      let httpReg = new RegExp('(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]', 'g')
      if (httpReg.test(data)) {
        return data.replace(httpReg, `<a href="$&" target="_blank">$&</a>`)
      } else {
        return data
      }
    },
    getSpanArr (data, id, preMerge) {
      let spanArr = []
      if (data == null) {
        return
      }
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          spanArr.push(1)
          this.pos = 0
        } else {
          if (preMerge) {
            if (data[i][id] === data[i - 1][id] && this.arrayCol[preMerge][i] === 0) {
              // 上一列的单元格的值为0代表是合并，不是0就是没有合并
              spanArr[this.pos] += 1
              spanArr.push(0)
            } else {
              spanArr.push(1)
              this.pos = i
            }
          } else {
            if (data[i][id] === data[i - 1][id]) {
              spanArr[this.pos] += 1
              spanArr.push(0)
            } else {
              spanArr.push(1)
              this.pos = i
            }
          }
        }
      }
      this.arrayCol[id] = spanArr
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (this.report.mergeSame.includes(column.property)) {
        let currentMergeIndex = this.report.mergeSame.findIndex(n => n === column.property)
        let preMerge = ''
        if (currentMergeIndex) {
          preMerge = this.report.mergeSame[currentMergeIndex - 1]
        }
        this.getSpanArr(this.data, column.property, preMerge, rowIndex)
        const _row = this.arrayCol[column.property][rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    // 好像没地方在用, 先注释, 后续可删除
    // getDownLoadUrl (path) {
    //   return path.includes('USER') ? sessionStorage.getItem('ossDownloadUrl') : sessionStorage.getItem('ossDownloadUrl')
    // },
    handleSizeChange (val) {
      // 如果是被rc-report 所引用, 更改引用的请求页数
      if (this.referenceObjParam && this.referenceObjParam.type === 'rc-report') {
        this.referenceObjParam.params.size = val
      }
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    searchPage () {
      this.$emit('page', this.pagination)
      this.$nextTick(() => {
        // 翻页的时候让滚动条调整到最上方
        this.$refs.table.bodyWrapper.scrollTop = 0
      })
    },
    sort ({ column, prop, order }) {
      this.pagination.currentPage = 1
      if (prop != null) {
        let type = order === 'ascending' ? 'asc' : 'desc'
        this.pagination.sort = `${prop},${type}`
      } else {
        // 置空是为了清除上一次的排序
        this.pagination.sort = ''
      }
      this.searchPage()
      if (column) {
        this.myColumn = column
      } else {
        this.myColumn = {}
      }
    },
    // 重置排序
    clearSort () {
      this.$refs.table.clearSort()
    },
    getButtonState (button, index) {
      if (button.restrictiveCondition) {
        let conditons = JSON.parse(button.restrictiveCondition)
        let conditionValues = []
        conditons.forEach(m => {
          let column = this.report.columns.find(n => n.id === m.columnId)
          conditionValues.push(simpleCalculation.logic(m.condition, this.data[index][m.columnId], m.content, column.columnType))
        })
        if (conditionValues.includes(true)) {
          return true
        } else if (conditionValues.includes(true)) {
          return true
        }
      }
      return false
    },
    handleCommand (object) {
      this.myIndex = object.index
      this.doAction(object.button, object.rowId, object.mainTableId, object.name, object.row)
    },
    sortVisibility ({row, column, rowIndex, columnIndex}) {
      if (Object.keys(this.myColumn).length !== 0) {
        if (this.myColumn.property === column.property) {
          return 'sort-visibility'
        }
      }
    },
    batchDataColumns () {
      let columns = this.report.columns.filter(m => ['enum', 'varchar', 'date', 'datetime', 'time'].some(n => n === m.columnType.toLowerCase()))
      columns.forEach(m => {
        m.columnId = m.expressionText && m.expressionText.match(/\$\{(.+?)\}/g) && m.expressionText.match(/\$\{(.+?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[0]
        m.columnType = m.columnType.toLowerCase()
      })

      // 只需要主表列
      columns = columns.filter(m => {
        let tableId = m.expressionText && m.expressionText.match(/\$\{(.+?)\}/g) && m.expressionText.match(/\$\{(.+?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[1]
        if (tableId === 'undefined' || tableId === this.report.mainTableId) {
          return m
        }
      })

      let columnIds = columns.map(m => m.columnId)
      let components = {}

      // 将控件信息存进去
      this.$axios.post(`/form-api/components/component/propertiesByIds`, columnIds).then(res => {
        components = res.data
        columns.forEach(m => {
          m.component = {}
          m.need = false
          for (let key in components) {
            if (key === m.columnId) {
              m.need = true
              m.component = JSON.parse(components[key])
            }
          }
        })
        // 过滤出varchar 除文本框的控件，比如编码框这些不需要
        columns.forEach(n => {
          if (['rc-input', 'rc-combobox', 'rc-date'].some(e => e === n.component.componentType)) {
            n.need = true
          } else {
            n.need = false
          }
        })
        // 过滤出动态下拉框id这个列
        columns.forEach(n => {
          if (n.component.archived && n.component.archived.showColumnId) {
            n.need = false
          }
        })
        // 留下是日期框，文本框，下拉框（静态数据源）
        this.batchData.columns = columns.filter(el => el.need)
      })
    },
    getType (columnId) {
      if (columnId) {
        let column = this.batchData.columns.find(n => n.columnId === columnId)
        return column.columnType
      }
    },
    changeColumnId (columnId) {
      this.batchData.replaceValue = ''
      let column = this.batchData.columns.find(n => n.columnId === columnId)
      if (column.columnType === 'enum') {
        this.batchData.options = []
        column.component.template.stringOptions.trim().split('\n').forEach(o => {
          this.batchData.options.push({label: o, value: o})
        })
      }
    },
    editBatch () {
      this.batchData.batchType = 'update'
      if (this.batchData.count > 0) {
        this.batchDataColumns()
        this.batchData.visible = true
      }
    },
    delBatch () {
      this.batchData.batchType = 'delete'
      if (this.batchData.count > 0) {
        this.$confirm('', '删除后无法找回，确定删除吗？', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          customClass: 'deleMessageBox',
          center: true
        }).then(() => {
          this.handleBatchData()
        })
      }
    },
    saveBatchData () {
      this.$refs.batchForm.validate((valid) => {
        if (valid) {
          this.handleBatchData()
        }
      })
    },
    cancelBatchData () {
      this.clearBatchData()
    },
    clearBatchData () {
      // 清空值
      this.batchData.replaceValue = ''
      this.batchData.type = ''
      this.batchData.columnId = ''
      this.batchData.visible = false
    },
    handleBatchData () {
      let params = {
        tableId: this.report.mainTableId,
        columnId: this.batchData.columnId,
        batchType: this.batchData.batchType,
        columnType: this.getType(this.batchData.columnId),
        replaceValue: this.batchData.replaceValue,
        ids: this.batchData.columnIds,
        removeIds: this.batchData.removeIds,
        handleType: this.batchData.handleType,
        filters: this.batchData.filters,
        reportId: this.report.id
      }
      this.$axios.post('/report-api/report/data/batchHandleReportData', params)
        .then((res) => {
          let message = this.batchData.batchType === 'update' ? '修改成功' : '删除成功，所选数据被删除'
          this.$message({
            message: message,
            type: 'success',
            duration: 2000
          })
          this.checkAll = false
          this.batchData.removeIds = []
          this.clearBatchData()
          this.$emit('search')
        }).catch(() => {
          this.clearBatchData()
          this.$emit('search')
        })
    },
    getRowClassName ({row, rowIndex}) {
      // 如果隔行变色开关开启了，则将偶数行背景颜色修改
      // 如果有合并同名就不执行隔行变色
      if (this.report.mergeSame && !this.report.mergeSame.length) {
        let className = ''
        if (this.report.bgColor) {
          if ((rowIndex + 1) % 2 === 0) {
            className = 'special-bgc'
          } else {
            className = 'borderNone'
          }
        }
        if (this.currentRow && JSON.stringify(this.currentRow) === JSON.stringify(row) && this.currentRow.Id === row.Id) {
          className += ' current-row'
        }
        return className
      }
    },
    indexMethod (index) {
      return (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1
    },
    handleCheckAllChange (val) {
      this.batchData.handleType = 1
      this.batchData.isBatch = val
      this.data.forEach(m => {
        m.checked = val
      })
      this.batchData.columnIds = this.data.filter(n => n.checked).map(m => m.Id)
      this.isIndeterminate = false
    },
    handleCheckCurrentPage () {
      this.batchData.handleType = 1
      this.data.forEach(m => {
        m.checked = true
      })
      this.batchData.columnIds = this.data.filter(n => n.checked).map(m => m.Id)
    },
    handleCheckAllPage () {
      this.batchData.removeIds = []
      this.batchData.handleType = 2
      this.data.forEach(m => {
        m.checked = true
      })
      this.batchData.count = this.count
      this.checkAll = true
      this.batchData.isBatch = true
      // 选择所有记录，传入筛选项
      this.batchData.filters = this.filtersData
    },
    checkCurrent (row) {
      if (this.batchData.handleType === 2) {
        if (row.checked) {
          let index = this.batchData.removeIds.findIndex(n => n === row.Id)
          if (index) {
            this.batchData.removeIds.splice(index, 1)
          }
          this.batchData.count++
        } else {
          this.batchData.removeIds.push(row.Id)
          this.batchData.count--
        }
        this.isIndeterminate = this.count !== this.batchData.count
        this.checkAll = this.count === this.batchData.count
      }
      if (this.batchData.handleType === 1) {
        this.batchData.columnIds = this.data.filter(n => n.checked).map(m => m.Id)
        this.isIndeterminate = !!this.batchData.columnIds.length
        this.checkAll = this.batchData.columnIds.length === this.pagination.pageSize
      }
    },
    // 获取表单所有的 控件
    getAllComponent (components, result = []) {
      for (let i = 0; i < components.length; i++) {
        components[i] && result.push(components[i])
        components[i].children && components[i].children.length > 0 && this.getAllComponent(components[i].children, result)
      }
      return result
    },
    setDataSource (data) {
      let index = this.comboboxDataSource.findIndex(c => c.id === data.id)
      if (index !== -1) {
        this.comboboxDataSource.splice(index, 1, {...data})
      } else {
        this.comboboxDataSource.push({...data})
      }
    },
    updateColumn (data, column) {
      let item = this.data.find(c => c.Id === column.Id)
      if (item) {
        this.$set(item, data.id, data.value)
      }
      this.$nextTick(() => {
        let children = this.$refs.editColmun
        children && children.length && children.forEach(c => c && c.setControlHeight())
      })
    },
    getTableHeight () {
      if (this.isExpand) {
        return '100%'
      }
      // 设计页报表预览不是 60太多了，不知道为啥。。
      let minus = this.$route.path.includes('report-design-list') ? '38px' : '45px'
      return this.hasChildren ? '' : `calc(100% - ${minus})`
    },
    mouseLeave (row, column, cell, event) {
      this.batchData.activeIndex = 0
    },
    expandChange (row) {
      this.currentRow = row
      this.expandParams.count = 1
      this.$nextTick(() => {
        if (!this.tablePageHeight) {
          // 风琴报表高度暂时定为5条数据高度
          this.tablePageHeight = 282
        }
        this.expands = this.expands.includes(row._uuid) ? [] : [row._uuid]
      })
    },
    // 是否只包含更多模式下拉
    getJustHaveMoreTypeFilter () {
      if (this.report.filters.length === 0) return false
      let moreTypeFilters = this.report.filters.filter(m => m.filterType !== 'senior' && m.moreType)
      return moreTypeFilters.length === this.report.filters.length
    },
    isFileData (type, value) {
      // fixme: VARCHAR 不仅仅是数据源, 所以这里也没有严格区分数据源控件
      // fixme: 主要还是依赖值以$.$开头来判断是否文件, 这样特殊情况较少,同时如果文件的值不再是这样的格式, 这里也需要修改
      return !!(type && (type === 'VARCHAR' || type === 'ENUM') && value && (typeof value === 'string' && value.startsWith('$.$')))
    },
    // 图片展示
    showPicture (column) {
      if (!column.showPicture) {
        return false
      }
      let columnShowPicture = {}
      if (typeof column.showPicture === 'string') {
        columnShowPicture = JSON.parse(column.showPicture)
      } else {
        columnShowPicture = column.showPicture
      }
      return columnShowPicture
    },
    // 多个禁用条件下满足禁用且没有开启禁用说明才呈现灰色按钮
    isDisabled (row, button) {
      if (button.conditions) {
        return !!button.conditions.find(condition => row[condition.id] && !condition.tipsEnable)
      } else {
        return false
      }
    }
  },
  computed: {
    getExpandChildren () {
      if (!this.report.children) {
        return []
      }
      return this.report.children.filter(m => m.type === 'expand')
    },
    operationWidth () {
      let width = 0
      let displayButton = []
      if (this.getUpdateOrDelButtons.length > 3) {
        displayButton = this.getUpdateOrDelButtons.slice(0, 3)
      } else {
        displayButton = this.getUpdateOrDelButtons
      }
      let countWord = 0
      displayButton.forEach(item => {
        countWord += item.name.length
      })
      if (countWord > 15) {
        countWord = 15
      }
      // fixme:列宽度按照需求字数*12px仍然不够宽,现在暂时手动加上98px,视觉上刚好
      width = countWord * 12 + 108
      return width
    },
    getUpdateOrDelButtons () {
      if (this.report.buttons) {
        return this.report.buttons.filter(m => ['update', 'delete', 'look', 'custom-bottom', 'print-column', 'online-contract', 'action', 'transmission-create'].some(n => n === m.type))
      }
    },
    // 列类名设置
    getColumnClass () {
      return function (column) {
        let className = ''
        if (column.format && column.format.dataFormat && column.format.dataFormat.width) {
          className += ' width-no-auto '
        }
        if (column.lineWrap) {
          className += ' table-column-normal'
        }
        if (this.report && this.report.columnEdit && column.lineWrap) {
          className += ' column-edit'
        }
        if (column.columnType === 'FILE') {
          className += ' file-column-height'
        }
        return className.trim()
      }
    },
    getComponentType () {
      return column => {
        if (this.report && this.report.editColumns) {
          return `report-${JSON.parse(this.report.editColumns).find(e => e.id === column.id).componentType}`
        }
      }
    },
    judgeColumn () {
      // 需要过滤含有计算的列
      return column => this.report && this.report.editColumns && !!JSON.parse(this.report.editColumns).find(e => e.id === column.id) && !column.summary
    },
    getComponent () {
      return column => {
        if (this.allComponent.length) {
          let columnId = column.expressionText && column.expressionText.match(/\$\{(.+?)\}/g) && column.expressionText.match(/\$\{(.+?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[0]
          let component = this.allComponent.find(c => c.archive.columnId === columnId)
          if (component) {
            return component
          } else {
            let item = JSON.parse(this.report.editColumns).find(e => e.id === column.id)
            if (item) {
              return this.allComponent.find(c => c.id === item.componentId) || {}
            }
          }
        } else {
          return {}
        }
      }
    }
  }
}

</script>
<style lang="scss">
@import '@/assets/scss/common.scss';
.label-tooltip.el-tooltip__popper.is-light {
  height: 20px;
  line-height: 20px;
  color: #706c6a;
  background: #f8f8f8;
  border:none;
}
.report-component-container .el-main .report-container .report-content .el-table.table-list{
   height: auto;
   max-height: 100%;
   border-bottom: 1px solid #ebebeb;
   position: relative;
   .el-table__fixed {
     background: #fff;
   }
  .file-list {
    > .one-file {
      cursor: pointer;
      font-size: 14px;
      color: #55ACF1;
      &:hover{
        color: #318ED9;
        text-decoration: underline;
      }
    }
    .el-dropdown {
      .el-dropdown-link {
        cursor: pointer;
        .multiple-accessory{
          color: #54ABF1;
          &:hover{
            color: #318ED9;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.report-component-container .el-main .report-container .report-content .el-table.table-none-data {
  &::after {
    position: absolute;
    width: 100px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    content: '暂无数据';
    top: 45%;
    left: 45%;
    font-size: 12px;
    color: #999;
    background-color: transparent;
  }
}
.report-pagination-list {
   border: none;
   box-shadow: none;
   position: relative;
   .batch-handle {
    position: fixed;
    left: 0;
    top: 45px;
    width: 100%;
    padding: 4px;
    padding-left: 15px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 4px 0px rgba(205,205,205,0.34);
    border-radius:4px;
    z-index: 202;
    p {
      color: #151515;
      margin-bottom: 11px;
    }
    >div {
      display: inline-block;
      cursor: pointer;
      &.batch-edit{
        color: #B6B8B9;
        &:hover {
          color: var(--primary, #54ABF1);
        }
        &:active {
          color: var(--shade-1, #388DD2);
        }
      }
      &.batch-del {
        color: #F22A59;
        margin-left: 22px;
        &:hover {
          color: #DB0606;
        }
        &:active {
          color: #DB0606 ;
        }
      }
      &.out-batch{
        position: absolute;
        right: 24px;
        color: var(--primary, #55ACF1);
        &:active {
          color: var(--shade-1, #3a8ee6);
        }
      }
    }
  }
  .el-table.table-list {
    height: auto;
    &:before {
      height: 0px;
    }
    .el-checkbox__input.is-checked {
      .el-checkbox__inner{
        width: 14px;
        height: 14px;
        display: inline-block;
        background-color: #FFFFFF;
        &::after,&::before {
          border-color: var(--primary, #4592E4);
        }
      }
      &.is-indeterminate {
        .el-checkbox__inner::before {
          background-color: var(--primary, #4592E4);
        }
      }
    }
   .el-table__body-wrapper .cell-padding{
      .cell{
        color: inherit;
        padding: 0px 10px;
        font-size: 13px;
        span, span a{
          font-size: 13px;
        }
      }
    }
    .el-table__expanded-cell {
      padding: 0;
      margin: 0;
      z-index: 15;
    }
    .file-column-height {
      height: 37px;
    }
    .operation-button-column {
      .cell {
        .el-button {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
    th{
      &.is-leaf {
        padding: 0;
      }
      .cell{
        white-space: nowrap;
       &.label-cell{
         label {
           font-size: 12px;
         }
       }
      }
    }
    .table-column-normal{
      .cell.el-tooltip{
        white-space: normal;
      }
    }
    .column-edit {
      padding: 0;
      .cell {
        position: inherit;
        padding: 0 !important;
        overflow: inherit;
      }
    }
    .el-table__header-wrapper {
      .has-gutter {
        th:last-of-type.gutter{
          background-color: #f8f8f8;
        }
        th:nth-last-of-type(2){
          border-right: none;
        }
        .cell {
          >span{
            font-size: 12px;
          }
          .caret-wrapper {
            visibility: hidden;
            margin-right: -14px;
          }
          &:hover {
            .caret-wrapper {
              visibility: visible;
            }
          }
        }
        .sort-visibility {
          .cell .caret-wrapper {
            visibility: visible;
          }
        }
      }
    }
    .el-table__fixed-body-wrapper{
      .cell-padding .cell{
        font-size: 13px;
        span, span a{
          font-size: 13px;
        }
      }
      .button-style{
        width: 76px;
        margin: 0;
      }
    }
    .el-table__footer-wrapper {
      .has-gutter .cell {
         white-space: nowrap;
      }
    }
    .button-margin{
      margin-left: 8px;
    }
    .label-margin{
      margin-left: 6px;
    }
    .numerical {
      .cell {
        & > div {
          color: #666;
          cursor: pointer;
        }
      }
    }
    .serial-number {
      .cell {
        & > div {
          font-size: 12px;
        }
      }
    }
    .numerical-batchHandle {
     .cell> .el-checkbox {
        margin-left: 22px;
      }
    }
  }
  .el-table__fixed, .el-table__fixed-right {
    .el-table__fixed-header-wrapper{
      th{
        padding: 0;
         .cell{
          padding: 0;
        }
      }
      .el-table__header {
        .cell {
          font-size: 12px;
          .caret-wrapper {
            visibility: hidden;
            margin-right: -14px;
          }
          &:hover {
            .caret-wrapper {
              visibility: visible;
            }
          }
          & > span {
            font-size: 12px;
          }
        }
      }
    }
  }
  .el-table__fixed-right {
    box-shadow: none;
    .el-table__fixed-header-wrapper{
      tr th:nth-last-of-type(1){
        border-right: none;
      }
    }
  }
  .el-table__fixed-right-patch{
    background-color: #f8f8f8;
  }
  .el-table__fixed-right:before,
  .el-table__fixed:before {
    height: 0px;
  }
  .dropdown-menu {
     cursor: pointer;
     color: var(--light-5, #C5DFFF);
    &:hover{
      color: var(--light-4, #8CCDFF);
    }
  }
  .pagination-footer {
    .report-footer {
      padding-top: 6px;
      width: 70%;
      max-width: 70%;
    }
    .pagination-footer__count{
      float: right;
      color: #606266;
      margin-top: 10px;
      margin-right: 38px;
    }
  }
  .pagination-footer.rc-report-pagination-footer{
    margin-top: 9px;
    justify-content: flex-end;
    padding-right: 0;
    .el-pagination{
      padding-right: 0;
      .el-pagination__sizes{
        margin-right: 0;
      }
    }
  }
  .el-table__body tr.hover-row > td {
    background-color: #F5F9FE;
  }
}
.el-dropdown-menu{
    .el-dropdown-menu__item{
      text-align: center;
    }
  }
.batch-dialog {
    .el-dialog__header {
      padding: 5px 20px;
    }

    .el-dialog__body {
      height: 222px;
      padding: 16px 25px 12px;

      p {
        text-align: center;
        color: #B9B5B5;
        margin-bottom: 20px;
      }

      div .el-form.batch-form {
        width: 274px;
        margin: 0 auto;
        .item-required label::before{
          display: none;
        }
         .el-form-item {
           margin-bottom: 30px;
            &.batchData-type {
              margin-bottom: 14px;
              .el-radio-group {
                .el-radio__inner {
                  border-radius: 0;
                }

                .el-radio.is-checked {
                  span.el-radio__label {
                    color: #606266;
                  }

                  span.el-radio__input {
                    width: 14px;
                    height: 16px;
                    display: inline-block;
                    background: url('../../form/componentAttr/assets/select.png') no-repeat;
                    background-size: 14px;

                    .el-radio__inner {
                      display: none;
                    }
                  }
                }
              }
            }
          .el-form-item__content {

            .el-input,
            .el-input .el-input__inner {
              width: 175px;
              height: 30px;
            }
          }
         }
      }
    }
    .el-dialog__footer {
      .el-button {
        padding: 5px 20px;
      }
    }
  }
.report-component-container {
  .el-main {
    .report-container {
      .report-content {
        .report-pagination-list  {
          .el-table {
            .el-table__body {
              .special-bgc {
                background-color: #F9F9F9;
                td {
                  border: none;
                }
              }
              .borderNone {
                td {
                  border: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
.dropdown-batch {
  .el-dropdown-menu__item:hover {
    background-color: #E2F1FE;
  }

}
span.appoint-column-name, a.appoint-column-name, .span.appoint-column-name {
   text-decoration: underline;
   color: #181818;
   cursor: pointer;
   &:hover {
      color: #55ACF1;
      text-decoration: underline;
   }
}
  .notSafari{
    .width-no-auto {
      .cell {
        width: 100%!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/table-pagination.vue